<form
    [formGroup]="variantsForm"
    #ngForm="ngForm"
    [name]="'simple-product-selector'"
    class="simple-product-selector"
    [class.background-opacity]="productPageFacade.isProductPageRevampEnabled"
    [attr.method]="'post'">
    <span
        hSrOnlyNoSnippet
        role="heading"
        i18n-role
        aria-level="3"
        i18n="@@hermes.accessibility.product-customizer-title">
        Customization and add to cart
    </span>

    <!-- colors selection-->
    @if (product?.variants?.colors) {
    <h-expansion-panel
        [role]="'accordion'"
        [expansionPanelId]="'color-variants'"
        [contentPadding]="'15px'"
        [collapsed]="!colorToggleOpened"
        (collapsedChange)="colorToggleOpened = !$event"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        [collapsable]="false">
        <ng-template [hExpansionPanelPart]="'header'">
            <ng-container>
                {{ product.attributes.colorHermesLabel }}
            </ng-container>
        </ng-template>
        <ng-template [hExpansionPanelPart]="'expansionPanel'">
            <span class="expansion-panel-text paragraph-medium" [attr.role]="'text'">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                </span>
                <div> {{ product.attributes.colorHermes | hSlashSpacer }}</div>
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
            </span>
        </ng-template>
        <div *hExpansionPanelPart="'content'">
            <h-product-variants
                [type]="'color'"
                [parentForm]="variantsForm"
                [variants]="product?.variants?.colors"
                [currentProduct]="product"
                [selectedValue]="selectedColorVariant?.refColoris"
                [moreVariantsEnabled]="true"
                [labelledById]="'toggle-title-color-variants'">
            </h-product-variants>
            @if (isShadeFinderActivated() && product?.isShadeFinder) {
            <h-shade-finder-button></h-shade-finder-button>
            }
        </div>
    </h-expansion-panel>
    }
    <!-- size selection -->
    @if (product?.variants?.sizes) {
    <h-expansion-panel
        #sizeToggle
        [contentPadding]="'15px'"
        [role]="'accordion'"
        [expansionPanelId]="'size-variants'"
        [collapsed]="!sizeToggleOpened"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        (collapsedChange)="handleSizesToggled($event)"
        [borderBottomRemoved]="!product?.attributes.shippingInformation && !sizeToggleOpened && isMobile">
        <ng-template [hExpansionPanelPart]="'header'">
            <ng-container>
                {{ product.attributes.sizeLabel }}
            </ng-container>
            @if (selectedSizeVariant) {
            <span hSrOnlyNoSnippet>
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <ng-container i18n="@@hermes.accessibility.page-product.selected"> selected </ng-container>
            </span>
            }
        </ng-template>
        <div class="size-container" *hExpansionPanelPart="'content'">
            <div class="size-infos">
                <h-call-to-action-size-guide [product]="product" [withPaddingBottom]="true">
                </h-call-to-action-size-guide>
                <div class="size-alert-text">
                    @if ((ngForm.submitted || findInStorePressed) && displaySizeAlert()) {
                    <div class="size-alert-container">
                        <h-svg-icon name="exclamation"></h-svg-icon>
                        <div
                            class="size-alert"
                            i18n="@@hermes-commerce-product-options-configurator.please-select-an-option">
                            Please choose a size
                        </div>
                    </div>
                    }
                </div>
            </div>
            <h-product-variants
                [type]="'size'"
                [currentProduct]="product"
                [selectedValue]="selectedSizeVariant?.size"
                [variants]="product?.variants?.sizes"
                [labelledById]="'toggle-title-size-variants'"
                [parentForm]="variantsForm">
            </h-product-variants>
        </div>
    </h-expansion-panel>
    }

    <!-- volume selection-->
    @if (product?.variants?.volumes) {
    <h-expansion-panel
        class="variant-title"
        [role]="'accordion'"
        [expansionPanelId]="'volume-variants'"
        [contentPadding]="'15px'"
        [collapsed]="!volumeToggleOpened"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        (collapsedChange)="handleVolumesToggled($event)"
        [borderBottomRemoved]="!product?.attributes.shippingInformation && !volumeToggleOpened && isMobile">
        <ng-container *hExpansionPanelPart="'header'">
            {{ product.simpleAttributes.massVolumeLabel }}
        </ng-container>
        <div *hExpansionPanelPart="'content'">
            <h-product-variants
                [type]="'volume'"
                [currentProduct]="product"
                [selectedValue]="selectedVolumeVariant?.volume"
                [variants]="product?.variants?.volumes"
                [labelledById]="'toggle-title-volume-variants'"
                [parentForm]="variantsForm">
            </h-product-variants>
        </div>
    </h-expansion-panel>
    } @if (hasTopBorderForDeliveryInformation()) {
    <h-separator [lightColor]="true"></h-separator>
    }
    <h-product-delivery-details
        [product]="product"
        [shippingInformation]="product.attributes.shippingInformation"></h-product-delivery-details>
    @if (product?.variants?.sizes && product?.variants?.colors) {
    <h-separator [lightColor]="true"></h-separator>
    } @if (displayPerfumeEngravingBlock) {
    <h-perfume-engraving-selector
        [formGroup]="variantsForm"
        [storeEngravingLineByVolumeVariant]="storeEngravingLineByVolumeVariant">
    </h-perfume-engraving-selector>
    }

    <h-call-to-action-purchase
        [addToCartButtonIsDisplayed]="isAddToCartButtonDisplayed"
        [product]="product"
        [isProductEngraving]="isProductEngraving"
        [transparentBackground]="productPageFacade.isProductPageRevampEnabled"
        (addToCart)="addToCartAction($event)">
    </h-call-to-action-purchase>

    <!-- Display the Find In Store button if there is stock retail for the product AND Add To Cart button is not displayed -->
    @if ((!product.personalize || !product.stock.ecom) && product.stock.retail) {
    <div>
        <h-call-to-action-find-in-store
            [product]="product"
            [skus]="[product.sku]"
            [transparentBackground]="productPageFacade.isProductPageRevampEnabled"
            [shouldPreventProductLocatorLaunch]="shouldPreventProductLocatorLaunch()"
            (pressed)="findInStoreAction()"></h-call-to-action-find-in-store>
    </div>
    }

    <!-- A11Y Forms Error-->
    @if ((ngForm.submitted || findInStorePressed) && displaySizeAlert()) {
    <span
        id="size-alert-message"
        hSrOnlyNoSnippet
        [attr.role]="'alert'"
        i18n="@@hermes-commerce-product-options-configurator.please-select-an-option">
        Please choose a size
    </span>
    }
</form>
